export enum DataImportStatus {
  Complete = 'complete',
  Failed = 'failed',
  Importing = 'importing',
  InitiatingImport = 'initiatingImport',
  NotStarted = 'notstarted',
  Valid = 'valid',
  Validating = 'validating',
}
